/* @refresh reload */
import { render } from "solid-js/web";
import "./styles/tokens.css";
import "./styles/reset.css";
import App from "./App.tsx";

const root = document.getElementById("root");
if (!root) throw new Error("#root not found");

render(() => <App />, root);
